import styled from "styled-components";

const Card = styled.div`
  min-height: ${p => p.height || '50vh'};
  background-color: #FFF;
  padding: 50px 12% 50px 12%;
  border-radius: 20px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  
  -webkit-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
  -moz-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
  box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export default Card;
